import { auth } from 'routing/common';

const redirect = [
  {
    from: '/admin',
    to: '/',
    exact: true,
  },
  {
    from: '/admin/travel-agents',
    to: '/',
  },
];

export default [...redirect, ...auth];
